import { AxiosPromise } from 'axios';
import { client }       from '@/service/client';

export function checkRateChecker(): AxiosPromise {
  return client.get('/rate-checker/availability');
}
